import type { RdLocationUnmatchedReason } from '@erp/rpc';

import type { FlagReason } from './types';

/** Shared STOCK_V / STOCKS_V unmatched-reason chips. */
export function rdLocationFlagReasons(
  reason: RdLocationUnmatchedReason,
  stockLocation: string,
  itemMasterLocation: string,
  itemColumn: string,
): FlagReason[] {
  if (reason === 'unmappedStockLocation') {
    return [
      {
        id: reason,
        column: 'STOCK ACCESS LOCATION',
        value: stockLocation,
      },
    ];
  }
  if (reason === 'stockItemLocationMismatch') {
    return [
      {
        id: reason,
        column: itemColumn,
        value: `${stockLocation}≠${itemMasterLocation}`,
      },
    ];
  }
  return [{ id: reason, column: itemColumn, value: itemMasterLocation }];
}
